// Firebase App (the core Firebase SDK) is always required and
// must be listed before other Firebase SDKs
import * as firebase from "firebase/app";

// Add the Firebase services that you want to use
import "firebase/auth";
import "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBIsT0K7mbJW1v31_eWyA-v2DlssCwgz_c",
  authDomain: "uni-notas.firebaseapp.com",
  databaseURL: "https://uni-notas.firebaseio.com",
  projectId: "uni-notas",
  storageBucket: "uni-notas.appspot.com",
  messagingSenderId: "495761757540",
  appId: "1:495761757540:web:05f0d3fb166be98205d671",
  measurementId: "G-74JH82YFET",
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export const db = firebase.firestore();
export const usersRef = db.collection("users");
export const institutesRef = db.collection("institutes");
export const careersRef = db.collection("careers");

export const fieldsRef = db.collection("lists").doc("fields");
export const pageMessagesRef = db.collection("lists").doc("pageMessages");

export default firebase;
